export default __webpack_public_path__ + "static/media/62-Deloitte.8b199506.jpg";